import React, { PropsWithChildren } from 'react';

import { Typography } from '@mui/material';

export default function SectionLabel({ children }: PropsWithChildren) {
  return (
    <Typography variant="overline" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
      {children}
    </Typography>
  );
}
